import { createUpsell } from '../upsell';
export const ZXnRCF = createUpsell({
    id: 'ZXnRCF',
    desc: 'Upsell sequence for RH coach with conditional logic - MX',
    seq: [
        {
            id: 'upsell-coach',
            onPurchase: ['upsell-yoga-healthy-back', 'upsell-digital-products-bundle'],
            onDecline: ['upsell-12-month', 'upsell-yoga-healthy-back', 'upsell-digital-products-bundle'],
        },
    ],
});
